<template>
    <div>
        <div class="news-banner">
            <img src="../../../assets/images/banner7.png" alt="">
        </div>
        <!-- 面包屑 -->
        <Breadcrumb separator=">" class="nav_rot">
            <Breadcrumb-item><router-link to="/">首页</router-link></Breadcrumb-item>
            <Breadcrumb-item><router-link to="/news">新闻中心</router-link></Breadcrumb-item>
            <Breadcrumb-item>公司动态</Breadcrumb-item>
        </Breadcrumb>

        <!-- 公司动态第一张内容 -->
        <div class="number_main">
            <p class="toptitle">司马大大发布智能庭审视频数据</p>
            <p class="toptitle">“冷存储+”解决方案，全面助力数字中国未来发展</p>
            <p class="con_p" style="margin-top: 60px;"> 2019年5月6日至8日，第二届数字中国建设峰会于福建省福州市召开。本次峰会的主题是“以信息化培育新动能，用新动能推动新发展，
                以新发展创造新辉煌”，旨在搭建我国信息化发展政策发布平台、电子政务和数字经济发展成果展示平台、数字中国建设理论经验和实践交流平台，
                汇聚全球力量助推数字中国建设。</p>

            <img src="../../../assets/images/96.png" alt="" style="margin-bottom: 5px;">
            <p class="bottom-mid">(图：第二届数字中国建设峰会)</p>
            
            <div class="box-text">
                <p>“智能庭审视频数据冷存储+”解决方案</p>
            </div>


            <p class="con_p" >
                在本次峰会中，司马大大(北京)智能系统有限公司（以下简称“司马大大”）联合战略合作伙伴，整合各家优势技术，首次推出致力于司法行业的
                “智能庭审视频数据冷存储+解决方案”<span style="font-weight:700">（展位号：10b07）</span>。本方案在传统庭审系统的基础上，引入AI压缩与永久“冷存储”技术，将相关视频媒资数据进行“冷”“热”“温” 
                的分类存储管理。最大限度地降低了司法行业视频媒资数据的存储空间，提升了视频大数据管理的效率。
            </p>


            <img src="../../../assets/images/97.png" alt="" class="img-main">
            <p class="bottom-mid">(图：智能庭审视频数据“冷存储+”系统)</p>
            <div class="box-text">
                <p>高清视频10倍以上无损压缩</p>
            </div>
            <p class="con_p">值得一提的是，在该系统中，司马大大利用自主创新的视频编解码技术，融合多种AI算法，形成了独特的视频压缩解决方案。
                目前，此项压缩技术在全球范围内具有绝对的领先优势与行业的不可替代性，能够在保证数字审判衍生视频数据画质的基础上，不改变原有视频帧率与时长，
                实现高清视频10倍以上的无损压缩，极大地降低了视频传输和存储的压力，从而解决了司法行业视频媒资管理高成本、高投入的行业痛点。</p>

            <img src="../../../assets/images/95.png" alt="" class="numimg_botttom">
            <p class="bottom-mid">(图：展会现场—视频大数据长期存储解决方案)</p>
            <div class="box-text">
                <p>基于冷存储+服务更多行业</p>
            </div>

            <p  class="con_p"> 在智能庭审视频数据冷存储+解决方案的基础上，未来，司马大大将继续加强与战略伙伴的合作，基于通用“冷存储+”技术，
                深植细分领域与垂直行业对视频数据存储时长与视频使用频率的需求，为其提供更加优质的服务与技术支持。</p>

            <img src="../../../assets/images/98.png" alt="" class="numimg_botttom" style="margin-top: 86px;">
            <p class="bottom-mid">(图：展会现场—深植监控行业，服务细分领域)</p>

        
        </div>
    </div>
</template>

<script>
import header from "../../cuscom/header";
export default {
    beforeRouteEnter: (to, from, next) => {
            next(vm => {
             window.scrollTo(0,0)
            });
        },
}
</script>

<style>
.news-banner {
     width: 100%;
 }
 .news-banner img {
     width: 100%;
     height: 100%;
 }
 

/* 面包屑 */
.nav_rot {
    width: 1200px;
    margin: 0 auto;
    font-size: 18px;
    margin-top: 35px;
}
.ivu-breadcrumb-item-link {
    color: #333333;
}


.number_main {
    width: 1200px;
    margin: 0 auto;
    color: #333;
    margin-top: 94px;
    overflow: hidden;
    padding-bottom: 60px;
}

.number_main .toptitle {
    font-size: 36px;
    /* font-weight: 700; */
    text-align: center;
}

.number_main .con_p {
    font-size: 14px;
    text-indent: 2em;
}
.number_main img{
    display: block;
    margin: 0 auto;
    margin-top: 26px;
}

/* 括号中的字 */
.bottom-mid {
    font-size: 12px;
    color: #333;
    margin: 0 auto;
    text-align: center;
    margin-top: 10px;
}

/* 图片下方框里的字 */
.box-text {
    width: 520px;
    height: 82px;
    border: 3px dashed #4472C4;
    margin:  0 auto;
    padding: 20px;
    margin-top: 90px;
    margin-bottom: 65px;
}
.number_main .box-text p {
    font-size: 26px;
    font-weight: normal;
    text-align: center;
}

.img-main {
    width: 635px;
    height: 477px;
    margin-bottom: 0px;
    border: 3px solid #4472C4;
}

.numimg_botttom {
    width: 555px;
    height: 417px;
}
</style>



// WEBPACK FOOTER //
// src/components/news/numbers/numbers.vue